<div
    *ngIf="resourceItem$ | async; let resourceItem"
    fxLayout="row"
    fxLayoutAlign="start start"
    fxLayoutGap="5px"
    class="navigate-container"
>
    <div class="file-parent-wrap-items">
        <div
            *ngIf="resourceItem.isDocType()"
            fxLayout="column"
            class="file-parent-wrap-items-item"
            fxLayoutAlign="center start"
        >
            <app-media-view [media_id]="resourceItem.name" [ignoreThumbnail]="true" [showImgModalOnClick]="true">
            </app-media-view>
        </div>
        <div class="item-content w-100">
            <div
                *ngIf="resourceItem.item_type_value === 'text_material'"
                [innerHtml]="resourceItem.name | innerHtml : 'tool_desc'"
            ></div>
            <app-media-view
                *ngIf="resourceItem.item_type_value === 'url_material'"
                [media_id]="resourceItem.name"
                [ignoreThumbnail]="true"
                [showImgModalOnClick]="true"
            ></app-media-view>
        </div>
        <div class="item-container-player" *ngIf="resourceItem.item_type_value === 'item_container'">
            <app-material-item-container-player [parentItem]="resourceItem"> </app-material-item-container-player>
        </div>
    </div>
</div>
